import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    FlatList
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import Filters from "./Filters";
import ProductDetails from "./ProductDetails";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let isMobile = false;
let scale = 1;


class OffersAndBestSellers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            showProductsDetails: false,
            productID: '',
            showFilters: false,
            isOffers: false,
            isBestSellers: false,
            searchText: '',
            tempQty: 1,
            isSearch: false,
            searched: false,
            itemsNo: 0,
            isSelected: false,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
        if (itemsInBasket) {
            const parsedItems = JSON.parse(itemsInBasket);
            this.setState({ itemsNo: parsedItems.length });
        } else {
            this.setState({ itemsNo: 0 });
        }
        const isOffers = this.props.isOffers;
        if (isOffers) {
            this.setState({ isOffers: true });
        }
        const isBestSellers = this.props.isBestSellers;
        if (isBestSellers) {
            this.setState({ isBestSellers: true });
        }
        let productsResp = await ServerOperations.getProducts('', this.state.consumerBrandFilter, this.state.categoryFilter, this.state.pharmaceuticalFilters);
        {
            this.state.isOffers && (
                productsResp = await ServerOperations.getOffers()
            )
        }
        {
            this.state.isBestSellers && (
                productsResp = await ServerOperations.getFeaturedBestSellers()
            )
        }
        this.setState({ products: productsResp, });
        loaderHandler.hideLoader();
    }


    renderMobile() {
        scale = width / 420;
        if (this.state.showProductsDetails) {
            return <ProductDetails self={this} productID={this.state.productID}
                showProductsDetails={(show) => { this.setState({ showProductsDetails: show, }) }} />;
        }
        if (this.state.showFilters) {
            return <Filters self={this} showFilters={(show) => { this.setState({ showFilters: show, }) }}
                consumerChosenFilters={this.state.consumerBrandFilter}
                pharmaChosenFilter={this.state.pharmaceuticalFilters}
                categChosenFilter={this.state.categoryFilter}
                productsLen={this.state.productsLen}
                brands={this.state.allFilters}
            />;
        }
        return (

            <View style={styles.container}>
                {Commons.renderAppHeader({}, this, '', this.state.products, this.state.products, this.state.isSearch, this.state.searched, this.state.searchText, this.state.itemsNo)}
                {this.renderPart1Mobile()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, }}>
                        {Commons.loadFonts(this,false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart2Mobile()}
                        {this.renderPart3Mobile()}
                    </View>
                    {/* {Commons.renderAppFooter({}, this)} */}
                </ScrollView>
                {Commons.renderAppFooter({}, this, '', '#52C0EE', '', '', '')}
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        width = Commons.getWidth();
        styles = this.styles();
        marginTop = 300;
        styles = this.styles();

        return (
            <View style={styles.container}>
                <Header
                    title={STRINGS.company_name}
                    leftView={Styles.drawerButtonDark(this.props.navigation)}
                    light={true}
                    navigation={this.props.navigation}
                    style={{ backgroundColor: this.state.scrolled ? 'rgba(192, 186, 94, 0.8)' : 'rgba(192, 186, 94, 1)' }}
                />
                <ScrollView scrollEventThrottle={100} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    {Commons.loadFonts(this,false)}
                    {this.renderPart1()}
                    {this.renderPart2()}
                    {this.renderPart3()}
                    {this.renderPart4()}
                    {Commons.renderFooter({}, this)}
                </ScrollView>
            </View>
        );
    }



    renderPart1 = () => {
    }



    renderPart1Mobile = () => {
        let title = STRINGS.appOffers;
        if (this.state.isBestSellers) {
            title = STRINGS.app_Best_Sellers;
        }
        return (
            <View>
                {this.state.isOffers && (
                    <Text style={[AppStyles.H2Styles]}>{title}</Text>
                )}
            </View>
        )
    }


    renderPart2 = () => {

    }



    renderPart2Mobile = () => {
        let columnNum = 2;
        if (this.state.isSearch) {
            columnNum = 1
        } else {
            columnNum = 2;
        }
        return (
            <View style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', width: width - 20, backgroundColor: '#FFF', marginHorizontal: 16 }}>
                {!this.state.isSearch && (
                    <FlatList
                        data={this.state.products}
                        keyExtractor={(item, index) => item.id?.toString() || index.toString()}
                        renderItem={({ item }) => {
                            let itemID = item.ITEM_NO;
                            if (this.state.isBestSellers) {
                                itemID = item.ID;
                            }
                            // this.filteredItems(item.ID);
                            return (
                                <TouchableOpacity
                                    style={{
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        borderRadius: 8,
                                        margin: 10,
                                    }}
                                    onPress={() => this.setState({ showProductsDetails: true, productID: itemID })}
                                >
                                    <Image
                                        source={item.IMG}
                                        style={{ width: (width - 60) / 2, height: (width - 60) / 2, borderRadius: 8, marginBottom: 8 }}
                                        resizeMode={item.IMG.indexOf('product.png') > 0 ? 'cover' : 'contain'}
                                    />
                                    <View style={{ width: '100%', alignItems: 'flex-start', width: 150 }}>
                                        <Text style={[AppStyles.OrderNowDescStyle]} >
                                            {item.NAME}
                                        </Text>
                                        <Text style={[AppStyles.orderNowPriceStyle, { marginTop: 2 }]}>{item.PHARMACY_PRICE} JOD</Text>
                                    </View>

                                    {Commons.addingItems(this, item, itemID, '', this.state.itemsNo, '')}

                                </TouchableOpacity>
                            )
                        }
                        }
                        contentContainerStyle={{ paddingVertical: 8, alignItems: 'center', justifyContent: 'center' }}
                        numColumns={2}
                    />
                )}

                {this.state.isSearch && (
                    Commons.renderSearchView(this)
                )}

            </View>
        )
    }


    renderPart3 = () => {

    }

    renderPart3Mobile = () => {

    }

    renderPart4 = () => {

    }

    renderPart4Mobile = () => {

    }

    renderPart5Mobile = () => {

    }



    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default OffersAndBestSellers;
